// @flow
import {compose, curry, isNil, map, reject, toLower, values} from 'ramda'

import type {Change, State} from '../types'

const moveItem = curry(
  (type, fromRoleDatabaseId, toRoleDatabaseId, {isSelected, databaseId}) => (
    isSelected
      ? {
        fromRoleDatabaseId,
        toRoleDatabaseId,
        type: `Move${type}`,
        [`${toLower(type)}DatabaseId`]: databaseId,
      }
      : null
  ),
)

const moveItems = (fn) => compose(reject(isNil), map(fn), values)

class ChangePayload {
  command: string
  state: State
  parentDatabaseId: string
  childDatabaseId: string

  constructor({command}: Change, state: State) {
    this.command = command
    this.state = state
    const {role, childSupportedRole} = state
    this.parentDatabaseId = role.databaseId
    this.childDatabaseId = childSupportedRole.databaseId
  }

  get policyItems() {
    const {policiesToMoveUp, policiesToMoveDown} = this.state
    const itemsUp = moveItems(moveItem('Policy', this.childDatabaseId, this.parentDatabaseId))
    const itemsDown = moveItems(moveItem('Policy', this.parentDatabaseId, this.childDatabaseId))
    return itemsUp(policiesToMoveUp).concat(itemsDown(policiesToMoveDown))
  }

  get roleItems() {
    const {rolesToMoveUp, rolesToMoveDown} = this.state
    const itemsUp = moveItems(moveItem('Role', this.childDatabaseId, this.parentDatabaseId))
    const itemsDown = moveItems(moveItem('Role', this.parentDatabaseId, this.childDatabaseId))
    return itemsUp(rolesToMoveUp).concat(itemsDown(rolesToMoveDown))
  }

  call(): Object {
    const body = JSON.parse(this.command)
    const commandBody = {
      ...body,
      roleDatabaseId: this.parentDatabaseId,
      childRoleDatabaseId: this.childDatabaseId,
      children: this.policyItems.concat(this.roleItems),
    }
    return {
      command: JSON.stringify(commandBody),
    }
  }
}

export default (change: Change, state: State): any => (new ChangePayload(change, state)).call()
